import React, { useState, useEffect } from 'react';
import { Box, Button, Divider, Typography, CircularProgress } from '@mui/material';
import { Google, GitHub, Microsoft } from '@mui/icons-material';
import { getOAuthProviders, initiateOAuthLogin } from '../../services/authService';

const OAuthButtons = ({ disabled = false }) => {
  const [providers, setProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [oauthEnabled, setOauthEnabled] = useState(false);

  useEffect(() => {
    const fetchProviders = async () => {
      try {
        const data = await getOAuthProviders();
        setProviders(data.providers || []);
        setOauthEnabled(data.oauth_enabled);
      } catch (error) {
        console.error('Failed to load OAuth providers:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchProviders();
  }, []);

  const getProviderIcon = (providerName) => {
    switch (providerName) {
      case 'google':
        return <Google sx={{ mr: 1 }} />;
      case 'github':
        return <GitHub sx={{ mr: 1 }} />;
      case 'microsoft':
        return <Microsoft sx={{ mr: 1 }} />;
      default:
        return null;
    }
  };

  const getProviderColors = (providerName) => {
    switch (providerName) {
      case 'google':
        return {
          backgroundColor: '#4285f4',
          '&:hover': { backgroundColor: '#3367d6' }
        };
      case 'github':
        return {
          backgroundColor: '#333',
          '&:hover': { backgroundColor: '#24292e' }
        };
      case 'microsoft':
        return {
          backgroundColor: '#0078d4',
          '&:hover': { backgroundColor: '#106ebe' }
        };
      default:
        return {
          backgroundColor: '#1976d2',
          '&:hover': { backgroundColor: '#1565c0' }
        };
    }
  };

  const handleOAuthLogin = (provider) => {
    if (disabled) return;
    initiateOAuthLogin(provider);
  };

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" py={2}>
        <CircularProgress size={24} />
      </Box>
    );
  }

  if (!oauthEnabled || providers.length === 0) {
    return null;
  }

  return (
    <Box>
      <Divider sx={{ my: 3 }}>
        <Typography variant="body2" color="text.secondary">
          Or continue with
        </Typography>
      </Divider>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {providers.map((provider) => (
          <Button
            key={provider.name}
            variant="contained"
            fullWidth
            disabled={disabled}
            onClick={() => handleOAuthLogin(provider.name)}
            sx={{
              py: 1.5,
              color: 'white',
              textTransform: 'none',
              fontSize: '1rem',
              fontWeight: 500,
              ...getProviderColors(provider.name)
            }}
            startIcon={getProviderIcon(provider.name)}
          >
            Continue with {provider.display_name}
          </Button>
        ))}
      </Box>
    </Box>
  );
};

export default OAuthButtons;